import { Euro, CalendarClock, CheckCircle2, HelpCircle, Globe, Clock, ShieldCheck, ArrowUpRight } from "lucide-react";
import { etichettaFor, fmtCheckDate } from "@/lib/constants";

export function PublicGrantCard({ grant }) {
  const eti = etichettaFor(grant);
  const checkDate = fmtCheckDate(grant.ultimo_controllo);
  const confermati = grant.requisiti_confermati || [];
  const daVerificare = grant.requisiti_da_verificare || [];

  return (
    <div className="flex flex-col rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm" data-testid="public-grant-card">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`rounded-md px-2 py-1 text-[11px] font-bold ${eti.cls}`}>{eti.label}</span>
        <span className="rounded-md bg-slate-100 px-2 py-1 text-[11px] font-semibold text-slate-600">{grant.ente}</span>
        {typeof grant.compatibilita === "number" && (
          <span className="rounded-md border border-slate-200 px-2 py-1 text-[11px] font-semibold text-slate-600">
            {grant.compatibilita}% compatibilità
          </span>
        )}
      </div>

      <h3 className="mt-3 font-display text-lg font-bold leading-tight text-slate-900">{grant.titolo}</h3>
      {grant.sottotitolo && <p className="mt-1 text-sm text-slate-500">{grant.sottotitolo}</p>}
      {grant.motivazione_match && (
        <p className="mt-2 text-xs italic text-slate-500">Base: {grant.motivazione_match}</p>
      )}

      <div className="mt-3 grid gap-1.5 text-sm">
        {grant.importo_max && (
          <div className="flex items-center gap-2 text-slate-700">
            <Euro className="h-4 w-4 shrink-0 text-emerald-600" />
            <span className="font-semibold">{grant.importo_max}</span>
          </div>
        )}
        <div className="flex items-center gap-2 text-slate-600">
          <CalendarClock className="h-4 w-4 shrink-0 text-amber-500" />
          <span>Scadenza: {grant.scadenza || "Da verificare"}</span>
        </div>
      </div>

      {(confermati.length > 0 || daVerificare.length > 0) && (
        <div className="mt-3 space-y-2 rounded-xl border border-slate-100 bg-slate-50 p-3">
          {confermati.length > 0 && (
            <div>
              <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-emerald-700">
                <ShieldCheck className="h-3.5 w-3.5" /> Requisiti confermati
              </span>
              <div className="mt-1.5 flex flex-wrap gap-1.5">
                {confermati.map((c, i) => (
                  <span key={i} className="inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-emerald-200">
                    <CheckCircle2 className="h-3 w-3" />{c}
                  </span>
                ))}
              </div>
            </div>
          )}
          {daVerificare.length > 0 && (
            <div>
              <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-amber-700">
                <HelpCircle className="h-3.5 w-3.5" /> Da verificare
              </span>
              <div className="mt-1.5 flex flex-wrap gap-1.5">
                {daVerificare.map((c, i) => (
                  <span key={i} className="inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-medium text-amber-700 ring-1 ring-amber-200">
                    <HelpCircle className="h-3 w-3" />{c}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-400">
        {grant.link_ufficiale && (
          <a href={grant.link_ufficiale} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1 font-medium text-indigo-600 hover:underline">
            <Globe className="h-3.5 w-3.5" /> Fonte ufficiale <ArrowUpRight className="h-3 w-3" />
          </a>
        )}
        {checkDate && (
          <span className="inline-flex items-center gap-1">
            <Clock className="h-3.5 w-3.5" /> Controllato il {checkDate}
          </span>
        )}
      </div>
    </div>
  );
}
